import { render, staticRenderFns } from "./tva.vue?vue&type=template&id=683a8bfc&"
import script from "./tva.vue?vue&type=script&lang=js&"
export * from "./tva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports